// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__17f2o","checkboxCol":"Table_checkboxCol__AZEh9","emailCol":"Table_emailCol__1PJWX","actionCol":"Table_actionCol__mEoYZ"};